import { mapState } from 'vuex';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'ViewApi',
  components: {
    MarkdownItVueLight
  },
  data: function () {
    return {
      buttons01: [{
        title: this.$i18n_t('Common.open'),
        icon: 'fal fa-external-link',
        action: 'open',
        valid: true
      }]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    n1Protocol() {
      return process.env.VUE_APP_N1_API_PROTOCOL;
    },
    n1Host() {
      return process.env.VUE_APP_N1_API_HOST;
    },
    xapiHost() {
      // set --build-arg VUE_APP_XAPI_HOST=https://xapi-subdomain.domain.com in case you need it for customer on-prem installation
      return process.env.VUE_APP_XAPI_HOST;
    },
    fireflyHost() {
      return process.env.VUE_APP_FIREFLY_HOST;
    },
    // n20aUrl() {
    //   return process.env.VUE_APP_ENV === 'local'
    //     ? 'http://xapi.127.0.0.1.xip.io'
    //     : `${this.n1Protocol}://xapi.${this.n1Host}`;
    // },
    n20aText() {
      return this.$i18n_t('Common.api.n20a', {
        url: this.xapiHost ? `${this.n1Protocol}://${this.xapiHost}/swagger/v1/` : `${this.n1Protocol}://xapi.${this.n1Host}/swagger/v1/`
      });
    }
  },
  methods: {
    open(a) {
      let link;
      if (a === 'n20a') {
        link = this.xapiHost ? `${this.n1Protocol}://${this.xapiHost}/swagger/v1/` : `${this.n1Protocol}://xapi.${this.n1Host}/swagger/v1/`;
      }
      if (a === 'n10a') {
        link = 'https://apidocs.niota.io';
      }
      if (a === 'firefly') {
        link = `https://apidocs.${this.fireflyHost}`;
      }
      window.open(link, '_blank');
    }
  }
};